import React, { useState, useEffect } from "react";
import { getApiUrl } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HomeDescription = () => {
  const UserId = "66abc123def4567890abcd12";

  const [descriptions, setDescriptions] = useState([]);
  const [newDescriptions, setNewDescriptions] = useState([""]);
  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH DESCRIPTIONS ---------------- */
  const fetchDescriptions = async () => {
    try {
      const res = await fetch(getApiUrl("sampledescription-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      const result = await res.json();

      if (result.success) {
        setDescriptions(result.data || []);
      }
    } catch (err) {
      toast.error("Failed to load descriptions");
    }
  };

  useEffect(() => {
    fetchDescriptions();
  }, []);
  

  
  const handleAdd = async () => {
    const filtered = newDescriptions.filter((d) => d.trim() !== "");
    if (!filtered.length) return toast.error("Enter at least one description");

    setLoading(true);

    const res = await fetch(getApiUrl("sampledescription-add"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: UserId,
        descriptions: filtered,
      }),
    });

    const result = await res.json();
    setLoading(false);

    if (result.success) {
      toast.success("Descriptions added successfully");
      setNewDescriptions([""]);
      fetchDescriptions();
    } else {
      toast.error(result.message || "Add failed");
    }
  };

  /* ---------------- DELETE DESCRIPTION ---------------- */
  const handleDelete = async (index) => {
    const res = await fetch(getApiUrl("sampledescription-delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: UserId,
        index,
      }),
    });

    const result = await res.json();

    if (result.success) {
      toast.success("Description deleted");
      fetchDescriptions();
    } else {
      toast.error("Delete failed");
    }
  };

  /* ---------------- UPDATE DESCRIPTION ---------------- */
  const handleUpdate = async (index, value) => {
    const res = await fetch(getApiUrl("sampledescription-update"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: UserId,
        index,
        description: value,
      }),
    });

    const result = await res.json();

    if (result.success) {
      toast.success("Description updated");
      fetchDescriptions();
    } else {
      toast.error("Update failed");
    }
  };

  /* ---------------- INPUT HANDLER ---------------- */
  const handleInputChange = (i, value) => {
    const copy = [...newDescriptions];
    copy[i] = value;
    setNewDescriptions(copy);
  };

  const addInputField = () => {
    setNewDescriptions([...newDescriptions, ""]);
  };

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={4000} />

      {/* HEADER */}
      <div className="d-flex justify-content-between mb-3">
        <h3 className="fw-bold">Home Description Management</h3>
      </div>

      {/* ADD BOX */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h5 className="fw-bold mb-3">Add New Descriptions</h5>

          {newDescriptions.map((desc, i) => (
            <input
              key={i}
              type="text"
              className="form-control mb-2"
              placeholder={`Enter description ${i + 1}`}
              value={desc}
              onChange={(e) => handleInputChange(i, e.target.value)}
            />
          ))}

          <button
            className="btn btn-secondary btn-sm me-2"
            onClick={addInputField}
          >
            + Add More
          </button>

          <button
            className="btn btn-success"
            disabled={loading}
            onClick={handleAdd}
          >
            {loading ? "Saving..." : "Save Descriptions"}
          </button>
        </div>
      </div>

      {/* DESCRIPTION LIST */}
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="fw-bold mb-3">Active Descriptions</h5>

          {descriptions.length === 0 && (
            <p className="text-muted">No descriptions added yet</p>
          )}

          {descriptions.map((desc, index) => (
            <div
              key={index}
              className="border rounded p-2 mb-2 d-flex justify-content-between align-items-center"
            >
              <input
                type="text"
                className="form-control me-2"
                defaultValue={desc}
                onBlur={(e) =>
                  handleUpdate(index, e.target.value)
                }
              />

              <button
                className="btn btn-sm btn-danger"
                onClick={() => handleDelete(index)}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeDescription;
